import { HttpService } from "@/core";
import {
  UnitPageReq,
  UnitPageResp,
  UnitDetailResp,
  UnitReq,
  UnitSimpleListResp,
} from "./unit.interface";

export class UnitService {
  static usePageApi() {
    const api = (params: UnitPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/unit/page",
        params,
      });
    return HttpService.usePagination<UnitPageResp>(api);
  }
  static useImportApi() {
    const api = (url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/unit/import`,
        data: {
          url,
        },
      });
    return HttpService.useRequest<void>(api);
  }
  static useSimpleListApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/unit/unitList",
      });
    return HttpService.useRequest<UnitSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/unit/${id}`,
      });
    return HttpService.useRequest<UnitDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: UnitReq) =>
      HttpService.axios({
        method: "POST",
        url: "/unit",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: UnitReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/unit/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/unit/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useUploadUnit() {
    const api = (url) =>
      HttpService.axios({
        url: "/unit/settleUnit/importBatchCheck",
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<any>(api);
  }

  static useFinishUpload() {
    const api = (data) =>
      HttpService.axios({
        url: "/unit/settleUnit/importBatchAdd",
        data: {
          unitTypeReqs: data,
        },
        method: "post",
      });
    return HttpService.useRequest<void>(api);
  }
}
